import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Save, Image, RefreshCw } from 'lucide-react';

export function MediaSend() {
  const api = useApi();
  const { can } = useAuth();
  const [tab, setTab] = useState('hadees');
  const [current, setCurrent] = useState({});
  const [form, setForm] = useState({ image_url: '', caption: '' });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadCurrent(); }, []);

  async function loadCurrent() {
    setLoading(true);
    const d = await api.get('/media/current');
    if (d?.media) {
      setCurrent(d.media);
      setForm({
        image_url: d.media[tab === 'hadees' ? 'hadees_image' : 'status_image'] || '',
        caption: ''
      });
    }
    setLoading(false);
  }

  function handleTabChange(t) {
    setTab(t);
    const key = t === 'hadees' ? 'hadees_image' : t === 'status' ? 'status_image' : '';
    setForm({ image_url: current[key] || '', caption: '' });
  }

  async function save() {
    const key = tab === 'hadees' ? 'hadees_image' : tab === 'status' ? 'status_image' : tab === 'masjid' ? 'masjid_address' : '';
    if (!key) return;
    if (!form.image_url.trim()) return toast.error('URL ya address likhein');
    setSaving(true);
    const d = await api.post('/media/save', { key, value: form.image_url.trim() });
    if (d?.success) {
      toast.success('Save ho gaya!');
      setCurrent(p => ({ ...p, [key]: form.image_url.trim() }));
    } else {
      toast.error(d?.error || 'Error');
    }
    setSaving(false);
  }

  const TABS = [
    { id: 'hadees', label: '📿 Aaj ki Hadees' },
    { id: 'status', label: '🌿 Latest Status' },
    { id: 'masjid', label: '🕌 Masjid Address' },
  ];

  if (loading) return (
    <div style={{ textAlign: 'center', padding: 60 }}>
      <span className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="section-title">📸 Media Send</div>
          <div className="section-sub">Hadees, Status images aur Masjid address update karein</div>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={loadCurrent}>
          <RefreshCw size={13} /> Refresh
        </button>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => handleTabChange(t.id)} style={{
            padding: '8px 16px', background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500, marginBottom: -1,
            borderBottom: tab === t.id ? '2px solid var(--emerald-400)' : '2px solid transparent',
            color: tab === t.id ? 'var(--emerald-300)' : 'var(--text-muted)'
          }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ maxWidth: 560 }}>
        <div className="card">
          {tab === 'masjid' ? (
            <>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)' }}>🕌 Masjid ka Address</div>
              <div className="field">
                <label className="label">Address (text mein likhein)</label>
                <textarea className="textarea"
                  value={form.image_url}
                  onChange={e => setForm(p => ({ ...p, image_url: e.target.value }))}
                  disabled={!can('settings')}
                  placeholder="Allama Hassan Raza Naqshbandi Masjid, Mohallah XYZ, Lahore"
                  style={{ minHeight: 80 }}
                />
              </div>
              <div className="field">
                <label className="label">Google Maps Link (optional)</label>
                <input className="input"
                  value={form.caption}
                  onChange={e => setForm(p => ({ ...p, caption: e.target.value }))}
                  disabled={!can('settings')}
                  placeholder="https://maps.google.com/..."
                />
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)' }}>
                <Image size={14} style={{ marginRight: 6 }} />
                {tab === 'hadees' ? 'Hadees Image' : 'Status Image'} — Image URL
              </div>
              <div className="field">
                <label className="label">Image URL (Cloudinary ya koi bhi direct link)</label>
                <input className="input"
                  value={form.image_url}
                  onChange={e => setForm(p => ({ ...p, image_url: e.target.value }))}
                  disabled={!can('settings')}
                  placeholder="https://res.cloudinary.com/..."
                />
              </div>
              {form.image_url && (
                <div style={{ marginBottom: 16 }}>
                  <label className="label">Preview</label>
                  <img
                    src={form.image_url}
                    alt="preview"
                    style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, border: '1px solid var(--border)', display: 'block' }}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                </div>
              )}
            </>
          )}

          {can('settings') && (
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
              {saving ? ' Saving...' : ' Save Karein'}
            </button>
          )}

          {(current.hadees_image || current.status_image) && (
            <div style={{ marginTop: 16, padding: '10px 14px', background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)', borderRadius: 8, fontSize: 12, color: 'var(--emerald-300)' }}>
              ✅ Current {tab === 'hadees' ? 'Hadees' : 'Status'} image set hai. Bot mein users ko yahi dikhega.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MediaSend;
